// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ucWNt","newExpiryDate":"styles_newExpiryDate__3gshT","footer":"styles_footer__KNFN-"};